import {memo} from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import DailyCalendarTile from './dailyCalendarTile/dailyCalendarTile';
import {calculateEventHeight, calculateEventLeft, calculateEventTop} from '../../../../../utils/edReviewUtils';
import {COLUMN_GAP, DEFAULT_LEFT, OFFSET, SLOT_HEIGHT} from '../edReviewCalendarDaily';

const LockedSlotTiles = (
  {
    slots,
    colWidth,
    className,
    leftOffset,
    columnIndex,
    findEventIndex,

  }
  ) => {

  return !isEmpty(slots) &&
    slots?.map((slot, slotIndex) => {
      return slot?.locked && (
        <DailyCalendarTile
          locked
          session
          event={slot}
          key={slotIndex}
          className={className}
          options={{
            top: calculateEventTop({
              event: slot,
              slotHeight: SLOT_HEIGHT,
              offset: OFFSET,
            }),
            left: calculateEventLeft({
              event: slot,
              columnIndex: !isNil(columnIndex) ? columnIndex : findEventIndex(slot?.parentSession),
              leftOffset: DEFAULT_LEFT + leftOffset,
              columnGap: COLUMN_GAP,
              eventSlotWidth: colWidth,
              offset: OFFSET,
            }),
            height: calculateEventHeight({
              event: slot,
              eventSlotHeight: SLOT_HEIGHT,
              offset: OFFSET,
            }),
            width: colWidth,
          }}
        />
      )
    },
  );
}

export const NewLockedSlotTiles = (
  {
    slots,
    colWidth,
    findEventIndex,
    columnIndex,
    leftOffset,
    className,
    onSelectTime,
  }) => {
  return !isEmpty(slots) &&
    slots?.map((slot, slotIndex) => slot?.locked && (
      <DailyCalendarTile
        locked
        session
        event={slot}
        key={slotIndex}
        columnIndex={columnIndex}
        className={className}
        onSelectTime={onSelectTime}

        options={{
          top: calculateEventTop({
            event: slot,
            slotHeight: SLOT_HEIGHT,
            offset: OFFSET,
          }),
          left: calculateEventLeft({
            event: slot,
            columnIndex: !isNil(columnIndex) ? columnIndex : findEventIndex(slot?.parentSession),
            leftOffset: DEFAULT_LEFT + leftOffset,
            columnGap: COLUMN_GAP,
            eventSlotWidth: colWidth,
            offset: OFFSET,
          }),
          height: calculateEventHeight({
            event: slot,
            eventSlotHeight: SLOT_HEIGHT,
            offset: OFFSET,
          }),
          width: colWidth,
        }}
      />
    )
  );
}

LockedSlotTiles.propTypes = {
  slots: PropTypes.array,
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  leftOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

NewLockedSlotTiles.propTypes = {
  slots: PropTypes.array,
  colWidth: PropTypes.string,
  findEventIndex: PropTypes.func,
  leftOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(LockedSlotTiles, _isEqual);